export default __webpack_public_path__ + "static/media/RabihFirli.dbad1431.mp3";